module.exports = __webpack_public_path__ + "static/media/windowDark.58b5f70f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/windowDark.svg
// module id = 76
// module chunks = 0